function toggleNotifyForm(button) {
  const formBox = document.getElementById("notifyFormBox");
  const isVisible = formBox.style.display === "block";
  formBox.style.display = isVisible ? "none" : "block";
  button.classList.toggle("expanded", !isVisible);
}

document.addEventListener("DOMContentLoaded", function () {
  const notifyForm = document.getElementById("notifyForm");
  if (notifyForm) {
    notifyForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(notifyForm);

      fetch("https://kit0407.zeabur.app/webhook/92ba0802-5693-43ce-a9d9-692cdf5653d7", {
        method: "POST",
        body: formData
      })
      .then(response => {
        if (response.ok) {
          const messageBox = document.getElementById("successMessage");
          messageBox.textContent = "Submitted. Thank you!";
          messageBox.style.display = "block";
          notifyForm.reset();
        } else {
          alert("Submission failed. Please try again.");
        }
      })
      .catch(() => {
        alert("Something went wrong. Please try again.");
      });
    });
  }
});
